import React from 'react';

const OrderStatusRefunded = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(2 2)">
      <circle cx="10" cy="10" r="10" fill="#FB8B01" />
      <path
        fill="#FFF"
        d="M5.53 6.85v2.503h1.544c.85 0 1.337-.456 1.337-1.248 0-.778-.518-1.254-1.368-1.254H5.53zm0 3.566v2.803H4.194V5.742H7.23c1.57 0 2.554.902 2.554 2.337 0 .984-.518 1.808-1.409 2.13l1.632 3.01H8.48l-1.467-2.803H5.53zm8.71-2.959c1.436 0 2.337 1.109 2.337 2.928 0 1.808-.89 2.927-2.32 2.927-.814 0-1.441-.352-1.731-.953h-.088v2.673h-1.285V7.55h1.238v.938h.088c.326-.642.984-1.031 1.762-1.031zm-.403 4.762c.89 0 1.42-.69 1.42-1.834 0-1.146-.534-1.835-1.415-1.835-.876 0-1.425.705-1.43 1.835.005 1.134.549 1.834 1.425 1.834z"
      />
    </g>
  </svg>
);

export default OrderStatusRefunded;
